var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"element droppable",style:(_vm.style)},_vm.$listeners),[_c('img',{attrs:{"src":_vm.iconUrl,"alt":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }